import { SendRecoveryComponent } from './pages/send-recovery/component/send-recovery/send-recovery.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import { AppComponent } from './app.component';

const appRoutes: Routes = [

    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'recoverypassword',
    },
    {
        path: 'recoverypassword',
        loadChildren: () => import('./pages/recovery-password/recovery-password.module').then(m => m.RecoveryPasswordModule)
    },
    {
        path: 'sendrecovery',
        loadChildren: () => import('./pages/send-recovery/send-recovery.module').then(m => m.SendRecoveryModule)
    },
    {
        path: '**',
        redirectTo: 'recoverypassword'
    }
];

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        RouterModule.forRoot(
            appRoutes,
            {enableTracing: false} // <-- Enable it for debuggin
        ),
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {
}

